// Native structure verified against Beefree's base-one-column sample:
// https://github.com/BeefreeSDK/beefree-sdk-assets-templates/blob/master/v3%20Email%20Templates/base-one-column.json
// This is a new minimal template, not an HTML import or a GrapesJS conversion.
export const beefreeStarterTemplate = () => ({
  page: {
    template: { name: 'retention-pilot', type: 'basic', version: '2.0.0' },
    title: '',
    description: '',
    rows: [{
      type: 'one-column-empty',
      locked: false,
      container: { style: { 'background-color': 'transparent', 'background-image': 'none', 'background-repeat': 'no-repeat', 'background-position': 'top left' } },
      content: {
        style: { 'background-color': '#ffffff', 'background-image': 'none', 'background-repeat': 'no-repeat', 'background-position': 'top left', width: '600px', color: '#111827' },
        computedStyle: { rowColStackOnMobile: true }
      },
      columns: [{
        'grid-columns': 12,
        style: {
          'background-color': 'transparent', 'padding-top': '20px', 'padding-bottom': '20px', 'padding-left': '0px', 'padding-right': '0px',
          'border-top': '0px solid transparent', 'border-bottom': '0px solid transparent', 'border-left': '0px solid transparent', 'border-right': '0px solid transparent'
        },
        modules: [{
          type: 'mailup-bee-newsletter-modules-text',
          locked: false,
          descriptor: {
            style: { 'padding-top': '10px', 'padding-bottom': '10px', 'padding-left': '20px', 'padding-right': '20px' },
            computedStyle: { hideContentOnMobile: false },
            text: {
              style: { 'font-family': 'inherit', 'line-height': '150%', color: '#111827' },
              computedStyle: { linkColor: '#2563eb' },
              html: '<div class="txtTinyMce-wrapper" style="font-size:14px;line-height:21px"><p>Add your email content here.</p><p><a href="{{unsubscribe_url}}" style="color:#2563eb">Unsubscribe</a></p></div>'
            }
          }
        }]
      }]
    }],
    body: {
      type: 'mailup-bee-page-properties',
      webFonts: [],
      content: {
        style: { 'font-family': 'Arial, Helvetica, sans-serif', color: '#111827' },
        computedStyle: { messageBackgroundColor: 'transparent', linkColor: '#2563eb', messageWidth: '600px' }
      },
      container: { style: { 'background-color': '#f1f5f9' } }
    }
  }
});
